import React, { FC } from 'react';
import { ReactComponent as More } from '../../../assets/Common/More.svg';

export const MoreIcon: FC = () => <More />;
